import { createApp } from 'vue';
import meganavDesktopApp from '@/app/views/nav-desktop/nav-desktop.vue';

function init() {
  const meganavDesktopEl = document.getElementById('nav-desktop');
  if (meganavDesktopEl) {
    const app = createApp(meganavDesktopApp);
    app.provide('config', VueConfig);
    app.mount(meganavDesktopEl);
  }
}

export default init;
